/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import Signin from "./Signin";
import PortalScreen from "./PortalScreen";
import UpdatePassword from "./UpdatePassword";
import ZebraPrinterSample from "./ZebraPrinterSample";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

const SplashScreen = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    var storedData = localStorage.getItem("userDetails");
    if (storedData) {
      setIsLoggedIn(true);
    }
  }, []);

  if (isLoggedIn) {
    return <PortalScreen />;
  } else {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/updatePassword" element={<UpdatePassword />} />
          <Route path="/" element={<Signin />} />
          <Route
            path="/zebra-printer-sample"
            element={<ZebraPrinterSample />}
          />
          {/* <Route path="*" element={<Navigate to="/" />} /> */}
        </Routes>
      </BrowserRouter>
    );
  }
};

export default SplashScreen;
